import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

const NormalityTestResult = ({ norm }) => {
  // console.log("norm.result :>> ", norm.result);
  return (
    <div>
      <GraphHeader
        column={norm.column}
        dateTime={norm.dateTime}
        title={norm.title}
        analysisId={norm.id}
      />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        <Grid item xs={6} sm={6} md={6}>
          <h4>Method</h4>
          {norm.Methods.isShapiro && <h3>Shapiro-Wilk Test</h3>}
          {norm.Methods.isKolmogorov && <h3>Kolmogorov-Smirnov Test</h3>}
          {norm.Methods.isAndersonDarling && <h3>Anderson-Darling Test</h3>}
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Statistics</h4>
          {norm.Methods.isShapiro && (
            <h3>{formatOutput(norm.result.shapiroResult.statistic)}</h3>
          )}
          {norm.Methods.isKolmogorov && (
            <h3>{formatOutput(norm.result.kstestResult.statistic)}</h3>
          )}
          {norm.Methods.isAndersonDarling && (
            <h3>{formatOutput(norm.result.andersonResult.statistic)}</h3>
          )}
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>P-Value</h4>
          {norm.Methods.isShapiro && (
            <h3>{formatOutput(norm.result.shapiroResult.pvalue)}</h3>
          )}
          {norm.Methods.isKolmogorov && (
            <h3>{formatOutput(norm.result.kstestResult.pvalue)}</h3>
          )}
        </Grid>
      </Grid>
      <br />
      <ImageGraph
        url={norm.probabilityPlot}
        title="Probability Plot"
        column={norm.column}
        // percent={norm.inputs.confindence * 100}
        percent={95}
      />
      {norm.graphs.isHistogram ? (
        <ImageGraph
          url={norm.histogram}
          title="Histogram"
          column={norm.column}
          // percent={norm.inputs.confindence * 100}
          percent={95}
        />
      ) : null}
    </div>
  );
};

export default NormalityTestResult;
